import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateWorkflows } from '../../features/workflows/workflowsSlice'
import { getClientKeyWithAccessToken } from '../../lib/security'

export const useWorkflows = (setIsLoading, isLoading) => {
  const workflowsState = useSelector((state) => state.workflows)
  const queryState = useSelector((state) => state.workflows.filters)
  const { limit, offset, page, status, name } = queryState ? queryState : { ...null }
  const { accessToken, emailClient } = useSelector((state) => state.login)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLoading) {
      const baseUrlWorkflows = `${process.env.REACT_APP_BASEURL}/workflows`
      let url = buildUrl(baseUrlWorkflows)

      function buildUrl(baseUrl) {
        let url = `${baseUrl}?emailClient=${emailClient}&limit=${limit}&page=${page}&offset=${offset}`

        if (status?.length) url += `&status=${status}`

        if (name?.length) url += `&name=${name}`

        return url
      }

      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
          
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          }

          return fetch(process.env.REACT_APP_IS_DEMO ? '../../data/riskMatrixs.json' : url, options)
        })
        .then((res) => res.json())
        .then((res) => {
          if (res) {
            const { data, pagination } = res
            const businessWorkflows = data.filter((item) => item.context === 'business')
            const consumerWorkflows = data.filter((item) => item.context === 'consumer')

            const aux = {
              data,
              business: businessWorkflows,
              consumer: consumerWorkflows,
              pagination,
            }

            dispatch(updateWorkflows(aux))
            setIsLoading(false)

            if (!res.data?.length) {
              dispatch(updateWorkflows([]))
              setIsLoading(false)
            }
          }
        })
        .catch((error) => {
          console.error('[HOOK: useWorkflows] --> ', error)
          setIsLoading(false)
        })
    }
  }, [isLoading, queryState])

  return workflowsState
}
